module.exports = __webpack_public_path__ + "static/img/telegram-banner-betting-slip-pc.6fad74c.png";